$(document).ready(function(){

	////////////////// RECHERCHE //////////////////

	$('.headerSite-recherche-trigger').on('click', function(){
		// Ouverture
		if (!$(this).hasClass('active')){
			$(this).addClass('active');
			$(this).closest('.headerSite').addClass('rechercheOuverte');
			$('.headerSite-recherche input').focus();
		}
		// Fermeture
		else{
			$(this).removeClass('active');
			$(this).closest('.headerSite').removeClass('rechercheOuverte');
			$('.headerSite-recherche input').blur();
		}
	});
	// Fermeture avec la touche echap
	$(window).on('keydown', function(event) {
		if(event.keyCode == 27) {
			$('.headerSite-recherche-trigger.active').trigger('click');
		}
	});
	// Fermeture clickOutside
	$('body').on('click', function() {
		$('.headerSite-recherche-trigger.active').trigger('click');
	});
	$('.headerSite-recherche').on('click', function(event){
		event.stopPropagation();
	});


	/*\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/*/
	/*							FANCYBOX							*/
	/*\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/*/	

	$(".fancy, [data-fancybox]").fancybox({
		closeClickOutside : true,
		touch : true,
		loop : true,
		gutter : 30
	});

	
	/*\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/*/
	/*					POUR LES LIENS DE PARTAGE				*/
	/*\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/*/
	open_popup = function(url){

		mywidth = 500;
		myheight = 350;
		myleft = (screen.width - mywidth) / 2;
		mytop = (screen.height - myheight) / 2;
		window.open( url, 'nouvo', 'width='+mywidth+',height='+myheight+',scrollbars=1,resizable=0,menubar=0,toolbar=0,status=0,location=0,directories=0,left='+myleft+',top='+mytop);
	}


	/*\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/*/
	/*						MENU MOBILE									*/
	/*\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/*/	
	
	var animEnCours = false;
	var mobileBreakPoint = 1200;

	resetMenu = function(){
		$('.menuSite-bouton').removeClass("active");
		$(".menuSite-interne").removeAttr("style")
		$(".menuSite-interne > ul > li").css("left","0");
		$(".menuSite-retour").remove();

		if(window.innerWidth < mobileBreakPoint){
			$(".menuSite-interne > ul > li ul").css("display","none");
		}else{
			$(".menuSite-interne > ul > li ul").removeAttr("style");
		}
	}

	// ENRICHISSEMENT DU MENU
	$(".menuSite li ul").each(function () {
		// On met la classe parentLink sur les li qui contiennent des sous-ul
		$(this).parent('li').addClass('parentLink');
		// On rajoute la petite fleche qui servira pour naviguer dans les niveaux sur mobile
		$(this).parent('li').children('a').append('<span class="niveauEnfant"></span>');
	});

	//OUVERTURE MENU
	$('.menuSite-bouton').on('click', function(){
		if($(this).hasClass("active")){
			$(this).removeClass('active');
			//On reset le sous menu
			setTimeout(function(){ 
				resetMenu();
			}, 100);
		}else{
			$(this).addClass('active');
		}
	});
	 
	//NAVIGATION DANS LE MENU MOBILE
	$(".menuSite-interne .niveauEnfant").on('click', function () {

		if (window.innerWidth < mobileBreakPoint) {
			if ($(this).closest('li').children('ul').length > 0 && !animEnCours) {
				animEnCours = true;
				$(this).closest('li').children('ul').prepend('<li class="menuSite-retour"><a href="#" title="Retour au menu précédent">Retour</a></li>');
				$(this).closest('li').children('ul').css("display", "block");
				$(".menuSite-interne").stop(true, true).animate({ "left": "-=100%" }, 400, function () {
					animEnCours = false;
				});
				return false;
			} else {
				return true;
			}
		}
	});

	//CLICK FLECHE RETOUR
	$(".menuSite ul li").on("click", ".menuSite-retour", function(){
		var retour = $(this);
		if(!animEnCours){
			animEnCours = true;
			$(".menuSite-interne").stop(true,true).animate({"left":"+=100%"},400, function(){
				retour.parent("ul").css("display","none");
				retour.remove();
				animEnCours = false;
			});
		}
		return false;
	});

	/*
	 * RESIZE MENUS
	 */
	$(window).resize(function(){
		resetMenu();
	});


	/*\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/*/
	/*						DEBUG									*/
	/*\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/*/

	var isSafari = /constructor/i.test(window.HTMLElement) || (function (p) { return p.toString() === "[object SafariRemoteNotification]"; })(!window['safari'] || (typeof safari !== 'undefined' && safari.pushNotification));
	var isIE = window.navigator.msPointerEnabled;

	if (isSafari) {
		$('body').addClass('safariUser');
	}
	else if (isIE) {
		$('body').addClass('ieUser');
	}


});

